export const compactFilterSelectStyles = {
  container: (base, state) => ({
    ...base,
    width: state.selectProps.compactWidth || '100%',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: state.selectProps.compactHeight || 28,
    height: state.selectProps.compactHeight || 28,
    borderColor: 'var(--theme-color-1)',
    borderRadius: 50,
    boxShadow: 'none',
    cursor: 'pointer',
    fontSize: '0.76rem',
    lineHeight: 1.3,
    '&:hover': {
      borderColor: 'var(--theme-color-1)',
    },
    ...(state.isFocused && {
      borderColor: 'var(--theme-color-1)',
    }),
  }),
  valueContainer: (base) => ({
    ...base,
    height: '100%',
    padding: '0 8px 0 12px',
  }),
  singleValue: (base) => ({
    ...base,
    color: 'var(--theme-color-1)',
    margin: 0,
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--theme-color-1)',
    margin: 0,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '100%',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: 'var(--theme-color-1)',
    padding: '0 8px 0 2px',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
    transition: 'transform 120ms ease',
    '&:hover': {
      color: 'var(--theme-color-1)',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '100%',
    zIndex: 20,
    borderRadius: 8,
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'var(--theme-color-1)' : '#fff',
    color: state.isFocused ? '#fff' : '#3a3a3a',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: '0.76rem',
    padding: '6px 10px',
    '&:active': {
      backgroundColor: 'var(--theme-color-1)',
      color: '#fff',
    },
  }),
};
